import React, { useEffect, useState, useRef } from "react";
import NavigationBar from "../components/Navigation";
import Footer from "../components/Footer";
import Lottie from 'lottie-react';
import animationData from "../lotties/84036-circle-animation.json";
import meduse from '../video/meduse.mp4';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import "../styles/components/Apropos.scss";
import BackToTopButton from '../components/BackToTopButton';
import { useLanguage } from '../contexts/LanguageContext';
import cld from '../config/cloudinaryConfig';
import { format, quality } from '@cloudinary/url-gen/actions/delivery';
import { Helmet } from "react-helmet-async";


const Propos = () => {
  const { t } = useLanguage();
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);
  const [gradientSize, setGradientSize] = useState('0% 100%');

  const darkwaterImageUrl = cld.image('darkwater_jkk0bl').delivery(quality('auto')).delivery(format('auto')).toURL();
  const thaumaturgeBgUrl = cld.image('ozt2_te7rst').delivery(quality('auto')).delivery(format('auto')).toURL();
  const pinkTownBgUrl = cld.image('vykn_v3c_hf1hft').delivery(quality('auto')).delivery(format('auto')).toURL();
  const logoPinkTownBgUrl = cld.image('logoFooterChatGPT26_oxnohb').delivery(quality('auto')).delivery(format('auto')).toURL();


  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".animation-element");
      if (!elements || elements.length === 0) return; // Vérifie que les éléments existent
      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight - 100;
        if (isVisible) {
          element.classList.remove("animation-hidden");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    const target = document.querySelector('.pulsate-background');
    if (target) observer.observe(target);

    return () => {
      if (target) observer.unobserve(target);
    };
  }, []);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    if (sectionRef.current) { // Vérifie que sectionRef.current n'est pas null
      gsap.fromTo(
        sectionRef.current.querySelectorAll('h2, p'),
        { backgroundSize: '0% 100%' },
        {
          backgroundSize: '100% 100%',
          ease: 'none',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top center',
            end: 'center center',
            scrub: true,
            onEnter: () => console.log('Animation triggered'), // Vérifie dans la console
          },
        }
      );
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('apropos.seo.title')}</title>
        <meta
          name="description"
          content={t('apropos.seo.description')}
        />
        <link rel="canonical" href="https://moviefrenzy.ca/Propos" />
      </Helmet>
      <div className="Apropos"
        style={{
          backgroundImage: `url(${darkwaterImageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundBlendMode: "overlay",
          backgroundColor: "#200211",
          opacity: "0.9",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <NavigationBar />
        <section>
          <div id="PinkTown" style={{ backgroundImage: `url(${pinkTownBgUrl})` }}>
            <div id="logoPinkTown" style={{ backgroundImage: `url(${logoPinkTownBgUrl})` }}></div>
          </div>
          <div
            className="about-mf-shell"
            style={{
              backgroundColor: "#FFFFFF",
              width: "100%",
              position: "relative",
              height: "auto",
              zIndex: "1",
              marginTop: "-600px",
              paddingTop: "0px",
              paddingBottom: "50px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "clamp(1.15rem, 2vw, 1.5rem)",
            }}
          // className="pulsate-background"
          >
            <div
              className="row text-center about-mf-creator"
              style={{ padding: "25px", height: "100%" }}
            >
              <div
                className="col-12 col-md-6 d-flex align-items-center"
                style={{ marginTop: "40px" }}
              >
                <div
                  style={{
                    textAlign: "center",
                    margin: "10px",
                  }}
                  className="paraPropos scroll-reveal"
                >
                  <h2
                    className="text-left title-left"
                    style={{
                      color: "#200211",
                      textAlign: "left",
                      margin: "8px",
                    }}
                  >
                    {t('apropos.quiSuisJe')}
                  </h2>

                  <p
                    className="text-left para-left"
                    style={{
                      color: "#200211",
                      textAlign: "left",
                      margin: "8px",
                    }}
                  >
                    {t('apropos.quiSuisJeText')}
                  </p>
                </div>
              </div>

              <div className="col-12 col-md-6 d-flex align-items-center">
                <div
                  style={{
                    textAlign: "center",
                    margin: "10px",
                    marginTop: "60px",
                  }}
                  className="paraPropos scroll-reveal"
                >
                  <h2
                    className="text-left title-left"
                    style={{
                      color: "#200211",
                      textAlign: "left",
                      margin: "10px",
                    }}
                  >
                    {t('apropos.pourquoiMeChoisir')}
                  </h2>

                  <p
                    className="text-left para-left"
                    style={{
                      color: "#200211",
                      textAlign: "left",
                      margin: "10px",
                    }}
                  >
                    {t('apropos.pourquoiMeChoisirText')}
                    <br />
                    {t('apropos.jeSuis')}

                    <span
                      style={{
                        color: "#ff33cc",
                        fontFamily: "'Ralins Script'",
                        fontSize: "clamp(1.5rem, 4vw, 2.35rem)",
                        fontWeight: "bold",
                        fontStyle: "italic",
                      }}
                      className="nomDesigner"
                    >
                      {" "}{t('apropos.nomDesigner')}
                    </span>

                    {t('apropos.metier')}
                  </p>
                </div>
              </div>
            </div>

            <section className="about-mf-intro">
              <div className="about-mf-intro__content">
                <p className="about-mf-intro__eyebrow">
                  {t('apropos.intro.eyebrow')}
                </p>

                <h1 className="about-mf-intro__title">
                  {t('apropos.intro.title')}
                </h1>

                <p className="about-mf-intro__lead">
                  {t('apropos.intro.lead')}
                </p>

                <p className="about-mf-intro__text">
                  {t('apropos.intro.community')}
                </p>

                <p className="about-mf-intro__text about-mf-intro__data">
                  {t('apropos.intro.data')}
                </p>
              </div>
            </section>
          </div>
          <div className="row">
            <div
              style={{
                backgroundImage: "conic-gradient(from -190deg at 50% 50%, #000000, #D90093",
                height: '100%',
                position: "relative",
                width: "100%",
                zIndex: "-100",
              }}
              className="col-12 col-md-6 d-flex align-items-center w-100"
            >
              <div
                className="row"
                style={{
                  position: 'relative',
                  zIndex: '-500',
                  width: '100%',
                  margin: '0 auto',
                }}
              >
                <div
                  style={{
                    width: '100wh',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  <video
                    width="100%"
                    height="100%"
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      objectFit: 'cover',
                      objectPosition: 'center',
                      width: '100wh',
                      height: '100vh',
                      position: 'absolute',
                      top: 0,
                      borderRadius: '50%',
                    }}
                  >
                    <source
                      src={meduse}
                      type="video/mp4"
                      className="background-image-class"
                    />
                    Votre navigateur ne prend pas en charge la vidéo.
                  </video>

                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(32, 2, 17, 0.85)',
                      margin: '0 auto',
                    }}
                  ></div>

                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  ></div>
                </div>
              </div>

              <div>
                <div
                  style={{
                    color: "#D90093",
                    fontFamily: "Bebas Neue",
                    fontSize: "clamp(3rem, 8vw, 5.5rem)",
                    textAlign: "center",
                    position: "absolute",
                    left: "25%",
                    top: "35px",
                    width: "50%",
                    zIndex: "150",
                    textShadow:
                      "0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #D90093, 0 0 70px #D90093, 0 0 80px #D90093, 0 0 100px #D90093, 0 0 150px #D90093",
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                  }}
                  className="strokeImaginatif"
                >
                  {t('apropos.imaginatif')}
                </div>
              </div>

              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <Lottie
                  animationData={animationData}
                  loop={true}
                  autoplay={true}
                  onComplete={() => console.log("Animation loaded")}
                  onError={(err) => console.log(err)}
                  style={{
                    transform: "scale(2.75)",
                    zIndex: "100",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                />
                <div className="qualite">
                  <span
                    className="forgeron"
                    style={{
                      position: "absolute",
                      top: "-22%",
                      left: "-130%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "50%",
                      height: "80px",
                      width: "480px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FF33CC",
                        fontFamily: "Bebas Neue",
                        fontSize: "2.35rem",
                      }}
                    >
                      {t('apropos.forgeronCreativite')}
                    </span>
                  </span>
                  <span
                    className="perseverance"
                    style={{
                      position: "absolute",
                      top: "-35%",
                      left: "135%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "50%",
                      height: "270px",
                      width: "270px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FF33CC",
                        fontFamily: "Bebas Neue",
                        fontSize: "2.85rem",
                      }}
                    >
                      {t('apropos.perseverance')}
                    </span>
                  </span>
                  <span
                    className="determination"
                    style={{
                      position: "absolute",
                      top: "68%",
                      left: "156%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "50%",
                      height: "370px",
                      width: "370px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FF33CC",
                        fontFamily: "Bebas Neue",
                        fontSize: "3.65rem",
                      }}
                    >
                      {t('apropos.determination')}
                    </span>
                  </span>
                  <span
                    className="resilience"
                    style={{
                      position: "absolute",
                      top: "87%",
                      left: "-105%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "50%",
                      height: "265px",
                      width: "265px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FF33CC",
                        fontFamily: "Bebas Neue",
                        fontSize: "2.5rem",
                      }}
                    >
                      {t('apropos.resilience')}
                    </span>
                  </span>
                  <span
                    className="visionnaire"
                    style={{
                      position: "absolute",
                      top: "126%",
                      left: "30%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "50%",
                      height: "120px",
                      width: "180px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FF33CC",
                        fontFamily: "Bebas Neue",
                        fontSize: "1.95rem",
                      }}
                    >
                      {t('apropos.visionnaire')}
                    </span>
                  </span>
                </div>
                <div className="qualiteMobile">
                  <span className="forgeronMob animation-hidden animation-element">{t('apropos.forgeronCreativite')}</span>
                  <span className="perseveranceMob animation-hidden animation-element">{t('apropos.perseverance')}</span>
                  <span className="determinationMob animation-hidden animation-element">{t('apropos.determination')}</span>
                  <span className="resilienceMob animation-hidden animation-element">{t('apropos.resilience')}</span>
                  <span className="visionnaireMob animation-hidden animation-element">{t('apropos.visionnaire')}</span>
                </div>
              </div>
            </div>
            <h3 className="h3ServiceA">{t('apropos.thaumaturgeNumerique')}</h3>
            <div
              className="col-12 col-md-6 d-flex align-items-center background-image-class pulsate-background"
              style={{
                backgroundImage: `url('${thaumaturgeBgUrl}')`,
                height: isInView ? "1080px" : "810px",
                position: "relative",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                width: isInView ? "100%" : "85%",
                margin: "5% auto 5% auto",
                borderRadius: "5%",
                transform: isInView ? 'scale(0.95)' : 'scale(0.75)',
                border: isInView ? '5px solid #D90093' : 'none',
                boxShadow: isInView ? '0 0 10px #00FFFF, 0 0 20px #00FFFF, 0 0 30px #00FFFF, 0 0 40px #00FFFF, 0 0 70px #00FFFF, 0 0 80px #00FFFF, 0 0 100px #00FFFF, 0 0 150px #00FFFF' : 'none',
                transition: 'transform 0.75s ease', // Animation
              }}
            >
              <div className="strokeThaumaturge">{t('apropos.thaumaturgeService')}</div>
            </div>
            <h3 className="h3ServiceB">{t('apropos.aVotreService')}</h3>
          </div>
          <div
            ref={sectionRef}
            className="scroll-reveal2"
            style={{
              backgroundImage: `linear-gradient(90deg, #D90093, #00FFFF)`,
              backgroundClip: 'text',
              color: 'transparent',
              backgroundSize: '0% 100%',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            <h2 className="section-title"><span>{t('apropos.decouvrezExpertise')}</span></h2>
            <p>
              <span>
                {t('apropos.decouvrezExpertiseText')}
              </span>
            </p>
          </div>
        </section>
        {/* Intégration de l'iframe de test stylisée */}
        {/* <div className="iframe-container">
          <iframe
            src="https://philippebolducportfolio.ca/"
            title="Portfolio Philippe Bolduc"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div> */}
      </div>
      <div>
        <BackToTopButton />
      </div>
      <div className="actor-details-footer"
        style={{ maxWidth: '100%', maxHeight: '100%' }}
      >
        <Footer />
      </div>
    </>
  );
};

export default Propos;



